import { FuseErrorUtilsService } from "../helpers/errors";
import { QueryValidatorCheck } from "../helpers/query-validator";
const keyConditionMap = {
    $eq: "$eq",
    $lt: "$lt",
    $lte: "$lte",
    $gt: "$gt",
    $gte: "$gte",
    $between: "",
    $beginsWith: "",
};
const conditionMapPre = {
    $ne: "$ne",
    $exists: "",
    $in: "",
    $nin: "",
    $not: "",
    $contains: "",
    $notContains: "",
    $elemMatch: "",
    $nestedMatch: "",
};
const conditionMap = { ...keyConditionMap, ...conditionMapPre };
function hasQueryKeyCondition(key) {
    return Object.keys(keyConditionMap).includes(key);
}
function getQueryConditionExpression(key) {
    if (key && Object.keys(conditionMap).includes(key)) {
        const conditionExpr = conditionMap[key];
        if (conditionExpr) {
            return conditionExpr;
        }
    }
    return null;
}
function regex_pcre_beginWith(text) {
    return `(?i)\\A${text}`;
}
function regex_pcre_contain(text) {
    return `(?i)${text}`;
}
export class CouchFilterQueryOperation {
    operation__filterFieldExist({ fieldName }) {
        const result = {
            [fieldName]: { $exists: true },
        };
        return result;
    }
    operation__filterFieldNotExist({ fieldName }) {
        const result = {
            [fieldName]: { $exists: false },
        };
        return result;
    }
    operation__helperFilterBasic({ fieldName, val, conditionExpr, }) {
        if (conditionExpr) {
            return {
                [fieldName]: { [conditionExpr]: val },
            };
        }
        const result = {
            [fieldName]: { $eq: val },
        };
        return result;
    }
    operation__filterIn({ fieldName, attrValues }) {
        const result = {
            [fieldName]: { $in: attrValues },
        };
        return result;
    }
    operation__filterNotIn({ fieldName, attrValues, }) {
        const result = {
            [fieldName]: { $nin: attrValues },
        };
        return result;
    }
    operation__filterNot({ fieldName, selectorObjValues, }) {
        const selector = { ...selectorObjValues };
        const mConditions = [];
        Object.entries(selector).forEach(([conditionKey, conditionValue]) => {
            if (hasQueryKeyCondition(conditionKey)) {
                const _conditionKey01 = conditionKey;
                if (_conditionKey01 === "$beginsWith") {
                    QueryValidatorCheck.beginWith(conditionValue);
                    const _queryConditions = this.operation__filterBeginsWith({
                        fieldName: fieldName,
                        term: conditionValue,
                    });
                    mConditions.push(_queryConditions);
                }
                else if (_conditionKey01 === "$between") {
                    QueryValidatorCheck.between(conditionValue);
                    const _queryConditions = this.operation__filterBetween({
                        fieldName: fieldName,
                        from: conditionValue[0],
                        to: conditionValue[1],
                    });
                    mConditions.push(_queryConditions);
                }
                else {
                    const conditionExpr = keyConditionMap[conditionKey];
                    if (conditionExpr) {
                        const _queryConditions = this.operation__helperFilterBasic({
                            fieldName: fieldName,
                            val: conditionValue,
                            conditionExpr: conditionExpr,
                        });
                        mConditions.push(_queryConditions);
                    }
                    else {
                        QueryValidatorCheck.throwQueryNotFound(conditionKey);
                    }
                }
            }
        });
        if (mConditions.length) {
            let selectorValuesAll = {};
            for (const condition of mConditions) {
                selectorValuesAll = { ...selectorValuesAll, ...condition[fieldName] };
            }
            const result = {
                [fieldName]: { $not: selectorValuesAll },
            };
            return result;
        }
        return null;
    }
    operation__filterElementMatch({ fieldName, attrValues, }) {
        const result = {
            [fieldName]: {
                $elemMatch: attrValues,
            },
        };
        return result;
    }
    operation__filterContains({ fieldName, term }) {
        const result = {
            [fieldName]: { $regex: regex_pcre_contain(term) },
        };
        return result;
    }
    operation__filterNotContains({ fieldName, term }) {
        const result = {
            [fieldName]: { $not: { $regex: regex_pcre_contain(term) } },
        };
        return result;
    }
    operation__filterBetween({ fieldName, from, to, }) {
        const result = {
            [fieldName]: { $gte: from, $lte: to },
        };
        return result;
    }
    operation__filterBeginsWith({ fieldName, term }) {
        const result = {
            [fieldName]: { $regex: regex_pcre_beginWith(term) },
        };
        return result;
    }
    operation__filterNestedMatchObject({ fieldName, attrValues, }) {
        const results = [];
        Object.entries(attrValues).forEach(([subFieldName, queryval]) => {
            let _queryValue;
            if (queryval && typeof queryval === "object") {
                _queryValue = { ...queryval };
            }
            else {
                _queryValue = { $eq: queryval };
            }
            Object.entries(_queryValue).forEach(([condKey, val]) => {
                const conditionKey = condKey;
                if (!Object.keys(keyConditionMap).includes(conditionKey)) {
                    throw FuseErrorUtilsService.fuse_helper_createFriendlyError(`Invalid query key: ${conditionKey} @ NestedMatchObject`);
                }
                const conditionExpr = keyConditionMap[conditionKey];
                if (conditionExpr) {
                    const result = {
                        [`${fieldName}.${subFieldName}`]: { [conditionExpr]: val },
                    };
                    results.push(result);
                }
                else {
                    if (conditionKey === "$between") {
                        if (!(Array.isArray(val) && val.length === 2)) {
                            throw FuseErrorUtilsService.fuse_helper_createFriendlyError("$between query must be an array of length 2");
                        }
                        const [fromVal, toVal] = val;
                        const result = {
                            [`${fieldName}.${subFieldName}`]: { $gte: fromVal, $lte: toVal },
                        };
                        results.push(result);
                    }
                    else if (conditionKey === "$beginsWith") {
                        const result = {
                            [`${fieldName}.${subFieldName}`]: { $regex: regex_pcre_beginWith(val) },
                        };
                        results.push(result);
                    }
                    else {
                        throw FuseErrorUtilsService.fuse_helper_createFriendlyError(`Query key: ${conditionKey} not currently supported`);
                    }
                }
            });
        });
        return results;
    }
    operation__translateAdvancedQueryOperation({ fieldName, queryObject, }) {
        const queryConditions = [];
        Object.entries(queryObject).forEach(([condKey, conditionValue]) => {
            const conditionKey = condKey;
            if (conditionValue !== undefined) {
                if (conditionKey === "$between") {
                    QueryValidatorCheck.between(conditionValue);
                    const _queryConditions = this.operation__filterBetween({
                        fieldName: fieldName,
                        from: conditionValue[0],
                        to: conditionValue[1],
                    });
                    queryConditions.push(_queryConditions);
                }
                else if (conditionKey === "$beginsWith") {
                    QueryValidatorCheck.beginWith(conditionValue);
                    const _queryConditions = this.operation__filterBeginsWith({
                        fieldName: fieldName,
                        term: conditionValue,
                    });
                    queryConditions.push(_queryConditions);
                }
                else if (conditionKey === "$contains") {
                    QueryValidatorCheck.contains(conditionValue);
                    const _queryConditions = this.operation__filterContains({
                        fieldName: fieldName,
                        term: conditionValue,
                    });
                    queryConditions.push(_queryConditions);
                }
                else if (conditionKey === "$notContains") {
                    QueryValidatorCheck.notContains(conditionValue);
                    const _queryConditions = this.operation__filterNotContains({
                        fieldName: fieldName,
                        term: conditionValue,
                    });
                    queryConditions.push(_queryConditions);
                }
                else if (conditionKey === "$in") {
                    QueryValidatorCheck.in_query(conditionValue);
                    const _queryConditions = this.operation__filterIn({
                        fieldName: fieldName,
                        attrValues: conditionValue,
                    });
                    queryConditions.push(_queryConditions);
                }
                else if (conditionKey === "$nin") {
                    QueryValidatorCheck.notIn(conditionValue);
                    const _queryConditions = this.operation__filterNotIn({
                        fieldName: fieldName,
                        attrValues: conditionValue,
                    });
                    queryConditions.push(_queryConditions);
                }
                else if (conditionKey === "$elemMatch") {
                    QueryValidatorCheck.elemMatch(conditionValue);
                    const _queryConditions = this.operation__filterElementMatch({
                        fieldName: fieldName,
                        attrValues: conditionValue,
                    });
                    queryConditions.push(_queryConditions);
                }
                else if (conditionKey === "$nestedMatch") {
                    QueryValidatorCheck.nestedMatch(conditionValue);
                    const nestedMatchConditions = this.operation__filterNestedMatchObject({
                        fieldName: fieldName,
                        attrValues: conditionValue,
                    });
                    if (nestedMatchConditions?.length) {
                        for (const _queryCondition of nestedMatchConditions) {
                            queryConditions.push(_queryCondition);
                        }
                    }
                }
                else if (conditionKey === "$not") {
                    QueryValidatorCheck.not_query(conditionValue);
                    if (conditionValue && typeof conditionValue === "object") {
                        const _queryConditions = this.operation__filterNot({
                            fieldName: fieldName,
                            selectorObjValues: conditionValue,
                        });
                        if (_queryConditions) {
                            queryConditions.push(_queryConditions);
                        }
                    }
                }
                else if (conditionKey === "$exists") {
                    QueryValidatorCheck.exists(conditionValue);
                    if (String(conditionValue) === "true") {
                        const _queryConditions = this.operation__filterFieldExist({
                            fieldName: fieldName,
                        });
                        queryConditions.push(_queryConditions);
                    }
                    else if (String(conditionValue) === "false") {
                        const _queryConditions = this.operation__filterFieldNotExist({
                            fieldName: fieldName,
                        });
                        queryConditions.push(_queryConditions);
                    }
                }
                else {
                    const conditionExpr = getQueryConditionExpression(conditionKey);
                    if (conditionExpr) {
                        const _queryConditions = this.operation__helperFilterBasic({
                            fieldName: fieldName,
                            val: conditionValue,
                            conditionExpr: conditionExpr,
                        });
                        queryConditions.push(_queryConditions);
                    }
                    else {
                        QueryValidatorCheck.throwQueryNotFound(conditionKey);
                    }
                }
            }
        });
        return queryConditions;
    }
    operation_translateBasicQueryOperation({ fieldName, queryObject }) {
        const _queryConditions = this.operation__helperFilterBasic({
            fieldName: fieldName,
            val: queryObject,
        });
        return _queryConditions;
    }
    processQueryFilter({ queryDefs }) {
        let queryMainConditions = [];
        let queryAndConditions = [];
        let queryOrConditions = [];
        Object.keys(queryDefs).forEach((fieldName_Or_And) => {
            if (fieldName_Or_And === "$or") {
                const orKey = fieldName_Or_And;
                const orArray = queryDefs[orKey];
                QueryValidatorCheck.or_query(orArray);
                if (orArray && Array.isArray(orArray)) {
                    orArray.forEach((orQuery) => {
                        Object.keys(orQuery).forEach((fieldName) => {
                            const orQueryObjectOrValue = orQuery[fieldName];
                            if (orQueryObjectOrValue !== undefined) {
                                if (orQueryObjectOrValue && typeof orQueryObjectOrValue === "object") {
                                    const _orQueryCond = this.operation__translateAdvancedQueryOperation({
                                        fieldName,
                                        queryObject: orQueryObjectOrValue,
                                    });
                                    queryOrConditions = [...queryOrConditions, ..._orQueryCond];
                                }
                                else {
                                    const _orQueryConditions = this.operation_translateBasicQueryOperation({
                                        fieldName,
                                        queryObject: orQueryObjectOrValue,
                                    });
                                    queryOrConditions = [...queryOrConditions, _orQueryConditions];
                                }
                            }
                        });
                    });
                }
            }
            else if (fieldName_Or_And === "$and") {
                const andKey = fieldName_Or_And;
                const andArray = queryDefs[andKey];
                QueryValidatorCheck.and_query(andArray);
                if (andArray && Array.isArray(andArray)) {
                    andArray.forEach((andQuery) => {
                        Object.keys(andQuery).forEach((fieldName) => {
                            const andQueryObjectOrValue = andQuery[fieldName];
                            if (andQueryObjectOrValue !== undefined) {
                                if (andQueryObjectOrValue && typeof andQueryObjectOrValue === "object") {
                                    const _andQueryCond = this.operation__translateAdvancedQueryOperation({
                                        fieldName,
                                        queryObject: andQueryObjectOrValue,
                                    });
                                    queryAndConditions = [...queryAndConditions, ..._andQueryCond];
                                }
                                else {
                                    const _andQueryConditions = this.operation_translateBasicQueryOperation({
                                        fieldName,
                                        queryObject: andQueryObjectOrValue,
                                    });
                                    queryAndConditions = [...queryAndConditions, _andQueryConditions];
                                }
                            }
                        });
                    });
                }
            }
            else {
                if (fieldName_Or_And) {
                    const fieldName2 = fieldName_Or_And;
                    const queryObjectOrValue = queryDefs[fieldName2];
                    if (queryObjectOrValue !== undefined) {
                        if (queryObjectOrValue && typeof queryObjectOrValue === "object") {
                            const _queryCond = this.operation__translateAdvancedQueryOperation({
                                fieldName: fieldName2,
                                queryObject: queryObjectOrValue,
                            });
                            queryMainConditions = [...queryMainConditions, ..._queryCond];
                        }
                        else {
                            const _queryConditions = this.operation_translateBasicQueryOperation({
                                fieldName: fieldName2,
                                queryObject: queryObjectOrValue,
                            });
                            queryMainConditions = [...queryMainConditions, _queryConditions];
                        }
                    }
                }
            }
        });
        let queryAllConditions = {};
        if (queryMainConditions?.length) {
            for (const item1 of queryMainConditions) {
                if (item1) {
                    queryAllConditions = { ...queryAllConditions, ...item1 };
                }
            }
        }
        if (queryAndConditions?.length) {
            queryAllConditions.$and = queryAndConditions;
        }
        if (queryOrConditions?.length) {
            queryAllConditions.$or = queryOrConditions;
        }
        return queryAllConditions;
    }
}
